import { create } from "zustand";

export enum AuthStep {
  LOGIN = "login",
  OTP = "otp",
  REGISTER = "register",
}

interface AuthState {
  authStep: AuthStep;
  email: string;
  setAuthStep: (step: AuthStep) => void;
  setEmail: (email: string) => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  authStep: AuthStep.LOGIN,
  email: "",
  setAuthStep: (step) => set({ authStep: step }),
  setEmail: (email) => set({ email }),
}));
